import { EstensaColDef } from '../search-param.model';
import { TranslateService } from '@ngx-translate/core';
import { GridUtilitiesService } from '../../services/grid-utilities.service';

export function completeCdColumnDefs(translate: TranslateService, gridUtils: GridUtilitiesService): EstensaColDef[] {
    return [
        {
            colId: 'CompleteCdStatusColId',
            headerName: '',
            tooltipField: '',
            field: 'failed',
            width: 50,
            minWidth: 50,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellRenderer: 'successFailureRenderer',
            cellRendererParams: {
                state: 'failed',
                tooltipSuccess: 'MPSJobsSuccedeed',
                tooltipFailure: 'MPSJobsFailed',
                tooltipCancelled: 'MPSJobsCancelled',
            },
        },
        {
            colId: '0',
            headerName: translate.instant('ID'),
            headerTooltip: translate.instant('ID'),
            field: 'jobID',
            width: 100,
            minWidth: 50,
            suppressSizeToFit: true,
        },
        {
            colId: '1',
            headerName: translate.instant('ExternalID'),
            headerTooltip: translate.instant('ExternalID'),
            field: 'external_ID',
            width: 150,
            minWidth: 50,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            colId: '2',
            headerName: translate.instant('Studies'),
            headerTooltip: translate.instant('Studies'),
            field: 'studies',
            width: 200,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            colId: '3',
            headerName: translate.instant('BusinessUnit'),
            headerTooltip: translate.instant('BusinessUnit'),
            field: 'businessUnit_Description',
            width: 200,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            // Client Description se non è vuoto, altrimenti client IP
            colId: '4',
            headerName: translate.instant('RequestedBy'),
            headerTooltip: translate.instant('RequestedBy'),
            field: 'hostname',
            width: 150,
            minWidth: 100,
            suppressSizeToFit: true,
        },
        {
            colId: '5',
            headerName: translate.instant('PatientName'),
            headerTooltip: translate.instant('PatientName'),
            field: 'patientName',
            width: 250,
            minWidth: 125,
            suppressSizeToFit: true,
        },
        {
            // Data
            colId: '6',
            headerName: translate.instant('BirthDate'),
            headerTooltip: translate.instant('BirthDate'),
            field: 'patientBirthDate',
            width: 150,
            minWidth: 75,
            suppressSizeToFit: true,
            hide: true,
            valueFormatter: gridUtils.dateFormatter('patientBirthDate'),
            comparator: gridUtils.dateComparator,
        },
        {
            // Data
            colId: '7',
            headerName: translate.instant('Sex'),
            headerTooltip: translate.instant('Sex'),
            field: 'patientSex',
            width: 125,
            minWidth: 50,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            // Data
            colId: '8',
            headerName: translate.instant('Exam'),
            headerTooltip: translate.instant('Exam'),
            field: 'jobDescription',
            width: 200,
            minWidth: 100,
            suppressSizeToFit: true,
        },
        {
            // Data
            colId: '9',
            headerName: translate.instant('Modality'),
            headerTooltip: translate.instant('Modality'),
            field: 'modalities',
            width: 125,
            minWidth: 50,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            // "Media_Type + ' ' + MultiCD"
            colId: '10',
            headerName: translate.instant('Disc'),
            headerTooltip: translate.instant('Disc'),
            field: 'multiCD',
            width: 125,
            minWidth: 50,
            suppressSizeToFit: true,
        },
        {
            //
            colId: '11',
            headerName: translate.instant('Copies'),
            headerTooltip: translate.instant('Copies'),
            field: 'copies',
            width: 125,
            minWidth: 50,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            // data
            colId: '12',
            headerName: translate.instant('Queued'),
            headerTooltip: translate.instant('Queued'),
            field: 'iN_Time',
            width: 175,
            minWidth: 100,
            suppressSizeToFit: true,
            valueFormatter: gridUtils.dateTimeFormatter('iN_Time'),
            comparator: gridUtils.dateComparator,
        },
        {
            // data
            colId: '13',
            headerName: translate.instant('InPendingTime'),
            headerTooltip: translate.instant('InPendingTime'),
            field: 'iN_Pending_Time',
            width: 175,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
            valueFormatter: gridUtils.dateTimeFormatter('iN_Pending_Time'),
            comparator: gridUtils.dateComparator,
        },
        {
            // data
            colId: '14',
            headerName: translate.instant('InCreatingTime'),
            headerTooltip: translate.instant('InCreatingTime'),
            field: 'iN_Creating_Time',
            width: 175,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
            valueFormatter: gridUtils.dateTimeFormatter('iN_Creating_Time'),
            comparator: gridUtils.dateComparator,
        },
        {
            // data
            colId: '15',
            headerName: translate.instant('InBurnerTime'),
            headerTooltip: translate.instant('InBurnerTime'),
            field: 'iN_Burner_Time',
            width: 175,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
            valueFormatter: gridUtils.dateTimeFormatter('iN_Burner_Time'),
            comparator: gridUtils.dateComparator,
        },
        {
            // data
            colId: '16',
            headerName: translate.instant('MPSEndTime'),
            headerTooltip: translate.instant('MPSEndTime'),
            field: 'enD_Time',
            width: 175,
            minWidth: 100,
            suppressSizeToFit: true,
            valueFormatter: gridUtils.dateTimeFormatter('enD_Time'),
            comparator: gridUtils.dateComparator,
        },
        {
            //
            colId: '17',
            headerName: translate.instant('MPSServer'),
            headerTooltip: translate.instant('MPSServer'),
            field: 'mpsDescription',
            width: 150,
            minWidth: 100,
            suppressSizeToFit: true,
        },
        {
            //
            colId: '18',
            headerName: translate.instant('MPSBurner'),
            headerTooltip: translate.instant('MPSBurner'),
            field: 'robotDescription',
            width: 200,
            minWidth: 100,
            suppressSizeToFit: true,
        },
        {
            //
            colId: '19',
            headerName: translate.instant('Error'),
            headerTooltip: translate.instant('Error'),
            field: 'failureReason',
            width: 150,
            minWidth: 100,
            suppressSizeToFit: true,
        },
        {
            //
            colId: '20',
            headerName: translate.instant('ErrorDetails'),
            headerTooltip: translate.instant('ErrorDetails'),
            field: 'failureDescription',
            width: 250,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            //
            colId: '21',
            headerName: translate.instant('BusinessUnitCover'),
            headerTooltip: translate.instant('BusinessUnitCover'),
            field: 'useBUCover',
            width: 175,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
        },
        {
            //
            colId: '22',
            headerName: translate.instant('Tags'),
            headerTooltip: translate.instant('Tags'),
            field: 'tags',
            width: 150,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: true,
        },
    ];
}
